import React from 'react';

import SvgIcon from '~/components/core/SvgIcon';
import type { IconProps } from '~/components/icons/types';
import colors from '~/theme/tailwind/colors';

const CheckedCircle: React.FC<IconProps> = (props) => (
  <SvgIcon viewBox="0 0 20 20" fill="none" disableStrokeColor {...props}>
    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill={colors.teal[100]} stroke={colors.teal[700]} />
    <path
      d="M15.7145 7.4019L8.71452 14.4019C8.65355 14.4631 8.5811 14.5116 8.50134 14.5447C8.42157 14.5779 8.33605 14.5949 8.24967 14.5949C8.1633 14.5949 8.07778 14.5779 7.99801 14.5447C7.91824 14.5116 7.8458 14.4631 7.78483 14.4019L4.72233 11.3394C4.66129 11.2784 4.61286 11.2059 4.57983 11.1261C4.54679 11.0464 4.52979 10.9609 4.52979 10.8746C4.52979 10.7882 4.54679 10.7027 4.57983 10.623C4.61286 10.5432 4.66129 10.4708 4.72233 10.4097C4.78337 10.3487 4.85584 10.3002 4.9356 10.2672C5.01536 10.2342 5.10084 10.2172 5.18717 10.2172C5.2735 10.2172 5.35899 10.2342 5.43875 10.2672C5.5185 10.3002 5.59097 10.3487 5.65202 10.4097L8.25022 13.0079L14.7859 6.47331C14.9092 6.35002 15.0764 6.28076 15.2508 6.28076C15.4251 6.28076 15.5923 6.35002 15.7156 6.47331C15.8389 6.59659 15.9082 6.7638 15.9082 6.93815C15.9082 7.1125 15.8389 7.27971 15.7156 7.40299L15.7145 7.4019Z"
      fill={colors.teal[700]}
    />
  </SvgIcon>
);

export default CheckedCircle;
